import React, { useEffect } from 'react';
import TableContainer from '../Reusable/Table/TableContainer';
import { tableConfig } from './channelTableConfig';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllChannels } from '../../actions/channel';

const ChannelCard = (props) => {
  const dispatch = useDispatch();
  const { channelList, loading } = useSelector((state) => state.channelReducer);
  const { t, ChannelStatus } = props || {},
    { tableTitle, HeaderColumns } = t || {},
    { ACTIVE } = ChannelStatus || {};

  useEffect(() => {
    dispatch(fetchAllChannels());
  }, [dispatch]);

  return (
    <TableContainer
      tableId="channels"
      renderAction={false}
      tableCardStyle={`channel-card-table-header small-table-style`}
      translations={{ tableTitle, HeaderColumns }}
      tableConfig={tableConfig()}
      items={channelList.filter((channel) => channel.status === ACTIVE.value)}
      smallSearchSignal={true}
      loading={loading}
    />
  );
};

export default ChannelCard;
